import { z } from "zod";
import { getMnoConfig } from "@/context/mno/configs";

// Form Schema - Only phoneNumber (used in AuthForm component)
export const AuthenticationRequestFormSchema = z.object({
    phoneNumber: z.string()
        .transform(val => val.replace(/\s+/g, ''))
        .refine(val => {
            const config = getMnoConfig();
            const digitsOnly = val.replace(/^\+/, '');
            const totalLength = config.countryCode.length + digitsOnly.length;
            return /^[1-9]\d*$/.test(digitsOnly) && totalLength >= 9 && totalLength <= 17;
        }, {
            message: 'Invalid mobile number format.',
        }),
});

// API Schema - Extends form schema with mno
export const AuthenticationRequestSchema = AuthenticationRequestFormSchema.extend({
    mno: z.string().min(1, { message: 'MNO is required' })
});
